import { render, staticRenderFns } from "./BookingExtra.vue?vue&type=template&id=6461819a&scoped=true"
import script from "./BookingExtra.vue?vue&type=script&lang=js"
export * from "./BookingExtra.vue?vue&type=script&lang=js"
import style0 from "./BookingExtra.vue?vue&type=style&index=0&id=6461819a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6461819a",
  null
  
)

export default component.exports